module.exports = __webpack_public_path__ + "static/img/abtus_bg_1.06592cb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/abtus_bg_1.png
// module id = +5Vw
// module chunks = 0